import { PDKLenderIcon, PDKNoIcon } from '@/components/ui/pdk-icons';
import useLenders from '@/hooks/use-lenders';
import { useMemo } from 'react';
import type { Option } from '../../ui/combobox/combobox-popover';

const useLenderOptions = () => {
  const { lenders } = useLenders();

  const lenderOptions: (Option<string> & {
    id: string;
  })[] = useMemo(
    () => [
      {
        id: 'delete',
        value: 'delete',
        label: 'No Lender',
        icon: <PDKNoIcon className="h-3.5 w-3.5" />,
      },
      ...lenders.map((lender) => ({
        value: lender.name,
        id: lender.id,
        name: lender.name,
        label: lender.name,
        phone: lender.phone,
        email: lender.email,
        lender_type: lender.lender_type,
        // TODO: add logos
        icon: <PDKLenderIcon className="h-3.5 w-3.5" />,
      })),
    ],
    [lenders],
  );

  const getLenderOptionIDByValue = (value: string) => {
    return lenderOptions.find((option) => option.value === value)?.id;
  };

  return { lenderOptions, getLenderOptionIDByValue };
};

export default useLenderOptions;
